import { Component, OnInit } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { announcement_condition } from '../class/status';
import { announcement_urltype } from '../class/status';
import { menulist } from '../class/status';
import { page } from '../class/status';

@Component({
  selector: 'app-chattemplate',
  templateUrl: './chattemplate.component.html',
  styleUrls: ['./chattemplate.component.css']
})
export class ChattemplateComponent implements OnInit {
   replaceArrenable =[
    '下架','上架'
   ];

   replaceArrtype = [
    '全部','一般','官方'
   ];

   tcontent = [
        {title:'描述',content:'content'},
        {title:'性別',content:'gender',type:3},
        {title:'狀態',content:'is_enable',type:3},
        {title:'類型',content:'type',replaceArr:this.replaceArrtype},
        {title:'修改時間',content:'update_dt'},
        {title:'操作',content:'gg',type:3},
  ];
  pageobj:page = {page:0,count:10,total_count:0};
  now:string='0';
  menu_list:menulist = [{id:'0',name:'修改資料'}]
  type_option:menulist = [{id:'1',name:'一般'},{id:'2',name:'官方'}]
  gender_option:menulist = [{ id: '-1', name: "請選擇性別" },{ id: '1', name: "男" },{id: '2', name: "女" },{ id: '3', name: "不限(官方帳號)" }]
  show_condition_list:menulist = [{id:'1',name:'日期區間'},{id:'2',name:'觀看次數'},{id:'3',name:'點閱次數'}]
  edit_data:any=[];
  data:any=[];
  loading:boolean=false;
  tmp_img_b64:{};
  announcement_condition = announcement_condition;
  announcement_urltype = announcement_urltype;
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  constructor(public httpClient: HttpClient,) { }
  enumKeys=[];
  gender_list:any[] = [
    { "id": '-1', "name": "推播性別不限" },
    { "id": '1', "name": "男" },
    { "id": '2', "name": "女" },
    { "id": '3', "name": "不限(官方帳號)" },
  ]
  search_gender = '-1';

  chat_type_list:any[] = [
    { "id": '-1', "name": "推播類型不限" },
    { "id": '1', "name": "一般" },
    { "id": '2', "name": "官方" },
  ]
  search_chat_type = '-1';

  handleStatusChange(newStatus: any,item) {
    this.edit_data = item;
    this.edit_data.is_enable = newStatus.changestatus;
    this.update(0);
}

  ngOnInit(): void {
    this.init_list();
  }

  save(type:number){
    this.update(0);
  } 

  add(){
    this.update(1);
  }

  update(type:number){
    this.loading = true;
    const body = {data:this.edit_data,type:type};
    this.httpClient.post<any>("/update_chattemplate.php",body).subscribe(res => {
      this.loading = false;
      console.log(res);
      this.init_list();
    });
  }

  init_list(){
    this.loading = true; 
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.now,search_gender:this.search_gender,search_chat_type:this.search_chat_type};
    this.httpClient.post<any>("/get_chattemplate_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }


  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

}
